import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { GenerateCatalogKey } from './generate.i18n.js';
import { GENERATE_CATALOG } from './generate.i18n.js';

export type GenerateMessageId = `generate:${GenerateCatalogKey}`;

const PREFIX_LENGTH = 'generate:'.length;

/** `t()` for the stop-gap `generate:` scope (see `generate.i18n.ts`). */
export function useGenerateT(): { t: (id: GenerateMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: GenerateMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as GenerateCatalogKey;
      const raw = GENERATE_CATALOG[locale][key] ?? GENERATE_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
